import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const ORGANIZATION_MEMBER_REMOVE = gql(`
  mutation organizationMemberRemove($organizationId: ID!, $memberId: ID!) {
    organizationMemberRemove(organizationId: $organizationId, memberId: $memberId) {
      ... on Organization {
        __typename
        id
        members {
          __typename
          id
        }
      }
      ... on OrganizationNotFound {
        __typename
        id
      }
      ... on UserNotFound {
        __typename
        id
      }
    }
  }
`);

interface Props {
  organizationId: string;
  memberId: string;
}

export function useOrganizationMemberRemove({
  organizationId,
  memberId
}: Props) {
  return useMutation(ORGANIZATION_MEMBER_REMOVE, {
    variables: {
      organizationId,
      memberId
    }
  });
}
